import {Directive, ElementRef, HostListener, inject} from '@angular/core';

const INTERACTIVE_ELEMENTS = 'a, button, input, select, textarea, label';

/**
 * Makes the whole card clickable for pointer users by forwarding clicks to the element marked with `cardAction`:
 * buttons and links are clicked, inputs are focused.
 *
 * The marked element stays the only focusable control, so keyboard and screen reader users are not affected
 * and no interactive elements are nested.
 */
@Directive({
  selector: '[appClickableCard]',
  host: {
    'class': 'clickable-card'
  }
})
export class ClickableCardDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // clicks on the controls themselves are handled by them
    if (target.closest(INTERACTIVE_ELEMENTS)) {
      return;
    }
    // the user is selecting text, e.g. to copy the description
    if (window.getSelection()?.toString()) {
      return;
    }
    const action = this.host.nativeElement.querySelector<HTMLElement>('[cardAction]');
    if (action instanceof HTMLInputElement) {
      action.focus();
    } else {
      action?.click();
    }
  }
}
